import React from "react";
import "../PageStyles.css";

const Excellences = () => {
  return (
    <section className="page-section about-section">
      <h1>About Ottomun: Forging the Diplomatic Leaders of Tomorrow</h1>

      <p>
        Welcome to <strong>Ottomun</strong>, where diplomatic journeys begin and global
        perspectives are born. We are not just a Model United Nations conference; we are a
        pioneering educational movement that has been shaping young minds in Türkiye and beyond
        since 2010.
      </p>

      <p>
        As the first independent high school MUN conference in Türkiye, we ignited a passion for
        global affairs among students. A year later, we broke new ground again by launching{" "}
        <strong>OTTOMUN Juniors</strong>, the nation’s first independent conference for middle
        school students. And our commitment to nurturing future leaders starts early—we are proud
        to be the only conference in Türkiye conducting <strong>OTTOMUN KIDS</strong> for 4th
        graders.
      </p>

      <p>
        From the youngest delegates taking their first steps in diplomacy to seasoned high school
        students tackling complex global crises, Ottomun provides an unparalleled, continuous
        learning pathway.
      </p>

      <h2>A Legacy of Excellence and Impact</h2>
      <p>
        Since our inception, Ottomun has grown into Türkiye’s premier and largest student-run
        MUN conference for middle and high school students. Our story is told in numbers, but
        defined by the transformative experiences behind them:
      </p>

      <ul className="custom-bullet-list">
        <li>
          <strong>23,000+</strong> delegates inspired to become aware, educated, and global-minded.
        </li>
        <li>
          <strong>542</strong> committees simulating the fast-paced, complex world of diplomacy.
        </li>
        <li>
          <strong>114</strong> conferences fostering collaboration and problem-solving.
        </li>
        <li>
          A vibrant community of <strong>382 schools</strong> and <strong>26 nationalities</strong>,
          creating a truly international network.
        </li>
      </ul>

      <h2>The Ottomun Experience: More Than a Simulation</h2>
      <p>
        An Ottomun conference is a three-day immersion into the heart of global politics.
        We go beyond the gavel and procedure to create a dynamic environment where students
        don’t just learn about diplomacy—they live it.
      </p>

      <ul className="custom-bullet-list">
        <li>
          <strong>World-Class, International Staff:</strong> Selected from top universities
          worldwide, bringing expertise and mentorship to every session.
        </li>
        <li>
          <strong>Unforgettable Academic Rigor:</strong> From General Assemblies to
          specialized crises, backed by expert study guides and academic resources.
        </li>
        <li>
          <strong>A Stage for Your Voice:</strong> Empowering delegates to speak, persuade,
          and lead with confidence.
        </li>
        <li>
          <strong>Individualized Attention:</strong> Our staff provides personal support and
          mentorship to help every delegate excel.
        </li>
      </ul>
    </section>
  );
};

export default Excellences;
